import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import {
    Card,
    CardBody,
    CardHeader,
    Input,
    Spinner
} from "reactstrap";
import useOrderOverview from "./graph/useOrderOverview";

const SalesGrowthChart = ({ selectedCountry, province, city }) => {
    const [groupBy, setGroupBy] = useState("month");

    const {
        chartConfig,
        isLoading,
        error
    } = useOrderOverview(selectedCountry, groupBy, province, city);

    const handleGroupByChange = (e) => {
        setGroupBy(e.target.value);
    };

    if (error) {
        return (
            <Card className="border-0 shadow-sm w-100">
                <CardBody className="text-center py-5">
                    <div className="alert alert-danger mb-0">
                        Error al cargar el crecimiento de ventas.
                    </div>
                </CardBody>
            </Card>
        );
    }

    return (
        <Card className="border-0 shadow-sm w-100">

            <CardHeader className="bg-white border-0 d-flex justify-content-between align-items-center">

                <div>
                    <h5 className="mb-0 fw-bold">
                        Crecimiento de Ventas
                    </h5>

                    <small className="text-muted">
                        {groupBy === "month"
                            ? "Últimos 3 meses"
                            : "Últimos 5 días"}
                    </small>
                </div>

                <Input
                    type="select"
                    value={groupBy}
                    onChange={handleGroupByChange}
                    style={{ width: 120 }}
                    disabled={isLoading}
                >
                    <option value="month">
                        Mensual
                    </option>

                    <option value="day">
                        Diario
                    </option>
                </Input>

            </CardHeader>

            <CardBody className="pt-0">

                {isLoading ? (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: 320 }}
                    >
                        <Spinner color="primary" />
                    </div>
                ) : (
                    <ReactApexChart
                        options={chartConfig.options}
                        series={chartConfig.series}
                        type="area"
                        height={320}
                    />
                )}

            </CardBody>

        </Card>
    );
};

export default SalesGrowthChart;